import React, { useEffect } from "react";
import { MdErrorOutline, MdClose, MdInfoOutline } from "react-icons/md";
import "../../styles/ErrorPopup.css";

export interface ErrorPopupProps {
  open: boolean;
  title?: string;
  subtitle?: string;
  message: string;
  hint?: string;
  onClose: () => void;
  actionText?: string;
  onAction?: () => void;
}

export default function ErrorPopup({
  open,
  title = "Validation Error",
  subtitle = "QC action could not be completed",
  message,
  hint,
  onClose,
  actionText,
  onAction,
}: ErrorPopupProps) {
  // Support Esc key to dismiss
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  if (!open || !message) return null;

  return (
    <div className="error-popup-backdrop" onClick={onClose}>
      <div className="error-popup-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="error-popup-header">
          <div className="error-popup-icon-wrap">
            <MdErrorOutline size={26} />
          </div>
          <div className="error-popup-title-area">
            <h3>{title}</h3>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button
            type="button"
            className="error-popup-close-btn"
            onClick={onClose}
            title="Close Alert"
          >
            <MdClose size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="error-popup-body">
          <div className="error-popup-message">{message}</div>

          {hint ? (
            <div className="error-popup-hint">
              <MdInfoOutline size={18} />
              <span>{hint}</span>
            </div>
          ) : message.toLowerCase().includes("master mac") ? (
            <div className="error-popup-hint">
              <MdInfoOutline size={18} />
              <span>
                <strong>Resolution:</strong> Ensure this MAC ID is registered in the <strong>Master Mac ID List</strong> before attempting IQC or Final QC inspection.
              </span>
            </div>
          ) : null}
        </div>

        {/* Footer */}
        <div className="error-popup-footer">
          {actionText && onAction && (
            <button
              type="button"
              className="error-popup-btn-secondary"
              onClick={() => {
                onAction();
                onClose();
              }}
            >
              {actionText}
            </button>
          )}
          <button
            type="button"
            className="error-popup-btn-dismiss"
            onClick={onClose}
            autoFocus
          >
            Understood
          </button>
        </div>
      </div>
    </div>
  );
}

